import { QuestionAnswerMap } from '@care-portals/api-interfaces';

export const mensexhealthQuestions = [
  {
    field: 'mensexhealth_complete',
    isLast: true,
    label: `Thank you for completing this questionnaire, please select "Finish" to submit`,
    extras: { sendToBeluga: false },
    type: 'info',
    answer: {}
  },
  {
    class: 'ineligible',
    field: 'mensexhealth_ineligible',
    label: "We're sorry you don't qualify",
    subLabel: "We're not able to prescribe for you today",
    extras: { sendToBeluga: false },
    blockQuestionFlow: true,
    answer: {},
    type: 'info',
    isLast: true
  },
  {
    field: 'mensexhealth_sexAssignedAtBirth',
    label: 'What was your sex assigned at birth?',
    extras: { sendToBeluga: false },
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Male', key: 'male' },
        { value: 'Female', key: 'female' }
      ]
    }
  },
  {
    field: 'mensexhealth_height',
    label: 'What is your height in feet and inches?',
    type: 'info',
    answer: {
      type: 'text',
      name: 'mensexhealth_height'
    }
  },
  {
    field: 'mensexhealth_weight',
    label: 'What is your weight in pounds?',
    type: 'info',
    answer: {
      type: 'text',
      name: 'mensexhealth_weight'
    }
  },
  {
    field: 'mensexhealth_primaryConcerns',
    label:
      'What are your primary concerns related to your sexual health? Select all that apply',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          value: 'Difficulty obtaining or maintaining an erection',
          key: 'erectile_difficulty'
        },
        { value: 'Decreased sexual desire', key: 'decreased_desire' },
        { value: 'Difficulty becoming aroused', key: 'arousal_difficulty' },
        { value: 'Difficulty achieving orgasm', key: 'orgasm_difficulty' },
        { value: 'Other', key: 'other' }
      ]
    }
  },
  {
    field: 'mensexhealth_otherSymptoms',
    label: 'Tell us more about your other sexual health symptom(s)',
    type: 'info',
    answer: {
      type: 'text',
      name: 'mensexhealth_otherSymptoms'
    }
  },
  {
    field: 'mensexhealth_concernDuration',
    label: 'How long have you been experiencing these concerns?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Less than 3 months', key: 'less_than_3_months' },
        { value: '3 to 6 months', key: '3_to_6_months' },
        { value: 'More than 6 months', key: 'more_than_6_months' }
      ]
    }
  },
  {
    field: 'mensexhealth_distressImpact',
    label: 'Do these concerns cause you distress or affect your relationships?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'mensexhealth_physicalExam',
    label:
      'Have you had a physical exam with a healthcare provider in the past 5 years?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes, I am in good health', key: 'yes_good_health' },
        { value: 'Yes, but they found problems', key: 'yes_problems_found' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'mensexhealth_examIssues',
    label: 'Please explain any issues during your last physical exam',
    type: 'info',
    answer: {
      type: 'text',
      name: 'mensexhealth_examIssues'
    }
  },
  {
    field: 'mensexhealth_bloodPressureTaken',
    label: 'Was your blood pressure taken in the past year?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        {
          value: 'No, I will get a new blood pressure measurement',
          key: 'no_will_get_new'
        }
      ]
    }
  },
  {
    field: 'mensexhealth_bloodPressureValue',
    label: 'What was the value? (Example: 115/72)',
    type: 'info',
    answer: {
      type: 'text',
      name: 'mensexhealth_bloodPressureValue'
    }
  },
  {
    field: 'mensexhealth_medications',
    label: 'Do you take any of the following medicines? Select all that apply',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          value: 'Nitroglycerin spray, ointment, patches or tablets',
          key: 'nitroglycerin'
        },
        {
          value:
            'Isosorbide mononitrate, or isosorbide dinitrate (Isordil, Dilatrate, Sorbitrate, Imdur, Ismo, Monoket)',
          key: 'isosorbide'
        },
        { value: 'Other medicines containing nitrates', key: 'other_nitrates' },
        {
          value:
            'Alpha blocker medications: doxazosin (Cardura), prazosin (Minipress), terazosin (Hytrin)',
          key: 'alpha_blockers'
        },
        { value: 'Riociguat (Adempas)', key: 'riociguat' },
        { value: 'None apply', key: 'none', uncheckOthers: true }
      ]
    }
  },
  {
    field: 'mensexhealth_cardiovascularSymptoms',
    label: 'Do you experience any of the following cardiovascular symptoms?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          value:
            'Chest pain or shortness of breath when climbing 2 flights of stairs or walking 4 blocks',
          key: 'chest_pain_stairs'
        },
        {
          value: 'Chest pain or shortness of breath with sexual activity',
          key: 'chest_pain_sexual'
        },
        {
          value: 'Unexplained fainting or dizziness',
          key: 'fainting_dizziness'
        },
        {
          value: 'Prolonged cramping of the legs with exercise',
          key: 'leg_cramping'
        },
        { value: 'Abnormal heart beats or rhythms', key: 'abnormal_heartbeat' },
        { value: 'None of these apply to me', key: 'none', uncheckOthers: true }
      ]
    }
  },
  {
    field: 'mensexhealth_medicalConditions',
    label:
      'Do you have now, or have you ever had any of the following conditions? Select all that apply.',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          value: 'Priapism (erection lasting longer than 4 hours)',
          key: 'priapism'
        },
        { value: 'Low blood pressure', key: 'low_blood_pressure' },
        {
          value: 'Difficult to control blood pressure',
          key: 'difficult_bp_control'
        },
        { value: 'History of stroke', key: 'stroke_history' },
        {
          value: 'A prior heart attack or heart failure',
          key: 'heart_attack_failure'
        },
        {
          value: 'Peripheral artery disease',
          key: 'peripheral_artery_disease'
        },
        { value: 'Idiopathic Hypertrophic Subaortic Stenosis', key: 'ihss' },
        {
          value:
            'Any areas of your skin that appear darker or discolored compared to your normal skin tone (hyperpigmentation)',
          key: 'hyperpigmentation'
        },
        { value: 'None apply', key: 'none', uncheckOthers: true }
      ]
    }
  },
  {
    field: 'mensexhealth_recentHeartAttack',
    label: 'Have you had a heart attack in the last six months?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'mensexhealth_conditionDetails',
    label: 'Please tell us more about the conditions you selected',
    type: 'info',
    answer: {
      type: 'text',
      name: 'mensexhealth_conditionDetails'
    }
  },
  {
    field: 'mensexhealth_peyroniesDisease',
    label:
      "Do you have a marked curve or bend in the penis that interferes with sex, or Peyronie's Disease?",
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'mensexhealth_activeBending',
    label:
      'Have you had active bending of your penis within the last 12 months?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'mensexhealth_painWithErection',
    label: 'Do you experience pain with erections or with ejaculation?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'mensexhealth_tightForeskin',
    label: 'Do you have a foreskin that is too tight?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { value: 'Yes', key: 'yes' },
        { value: 'No', key: 'no' }
      ]
    }
  },
  {
    field: 'mensexhealth_additionalQuestions',
    label: 'What other information or questions do you have for the doctor?',
    type: 'info',
    answer: {
      type: 'text',
      name: 'mensexhealth_additionalQuestions'
    }
  },
  {
    field: 'mensexhealth_consentPT141Oxytocin',
    label: "Consent (PT-141, Oxytocin, and Medications for Men's Libido):",
    type: 'select',
    educationalSlide:
      'This consent form explains the use of compounded PT‑141 (bremelanotide) and oxytocin, along with any additional medications, prescribed to address men\'s sexual health. By signing below, you acknowledge that these compounded products are not FDA‑approved for use in men and are prescribed off‑label. Because they are prepared by a compounding pharmacy, their concentration, purity, and sterility may vary from one batch to another. Limited data exist regarding their safety and effectiveness in men, and standardized dosing guidelines have not been established. It is important that you understand the purpose, potential benefits, risks, side effects, and your responsibilities throughout this treatment. Please review the following information carefully before providing consent.\n\nPurpose and Benefits:\nPT‑141 (Bremelanotide):\nStimulates melanocortin receptors in the brain, which may improve erectile function and overall sexual performance.\nMay lead to more reliable erections and enhanced sexual satisfaction.\nOxytocin:\nOften called the "bonding hormone," oxytocin can promote emotional intimacy and trust with a partner.\nMay improve sexual desire, enhance feelings of closeness, and contribute to a more fulfilling sexual experience.\nTogether, these treatments aim to address decreased libido, promote stronger erections, and support emotional well‑being in men experiencing sexual dysfunction.\n\nPotential Risks and Side Effects:\nWhile PT‑141 and oxytocin may offer benefits, they can also produce side effects that differ between individuals.\nCommon Side Effects of PT‑141:\nNausea or upset stomach\nHeadache\nFacial flushing or redness\nDizziness or lightheadedness\nInjection‑site reactions (if injectable formulation is used)\nCommon Side Effects of Oxytocin:\nMild headache\nNausea\nTemporary changes in blood pressure (either high or low)\nPossible mood or emotional fluctuations\nRare but Serious Risks (Both Medications):\nSignificant or sustained changes in blood pressure which could result in an increased risk of stroke or heart attack.\nSevere allergic reactions (e.g., swelling of the face, lips, tongue, or throat)\nNoticeable changes in mood or behavior that cause concern\nHyperpigmentation of the skin\nIf you have a known allergy to any of the ingredients, please inform your healthcare provider before starting treatment. Should you experience chest pain, difficulty breathing, extreme dizziness, or signs of a severe allergic reaction, seek emergency medical attention immediately.\n\nMonitoring Plan:\nYour healthcare provider will closely monitor your response to these treatments to ensure ongoing safety and effectiveness. This monitoring includes:\nFollow‑Up Visits: Attending all scheduled appointments for evaluation.\nDiagnostic Tests: Completing any recommended lab tests, blood pressure checks, or other assessments.\nSymptom Reporting: Informing your provider promptly of any new or worsening symptoms, including side effects or mood changes.\n\nAlternative Treatments:\nYou have the right to discuss other options for managing low libido or erectile dysfunction, such as:\nNon‑Pharmacological Therapies: Counseling, sex therapy, or relationship therapy to address psychological or relational factors.\nLifestyle Modifications: Regular exercise, improved sleep hygiene, stress reduction techniques, and nutritional changes.\nOther Medications or Hormonal Therapies: Depending on your overall health and specific needs, additional prescription or non‑hormonal options may be available.\n\nYour Responsibilities:\nAs a patient undergoing this off‑label treatment, you agree to:\nFollow the prescribed dosage and administration instructions precisely.\nAttend all follow‑up appointments and complete any recommended tests or evaluations.\nInform your healthcare provider of any new medications, supplements, or changes in your health status.\nReport any concerning side effects or unusual symptoms immediately.\nBy selecting below, you confirm that you have read and understood the information provided. You acknowledge the potential benefits and risks associated with the prescribed hormone therapy.. You agree to adhere to the recommended use, monitoring plan, and to communicate openly with your healthcare provider about any concerns.',
    answer: {
      type: 'single_select',
      options: [
        {
          value:
            'I have read the above information, and I do NOT wish to proceed.',
          class: 'option-decline',
          key: 'non_consent'
        },
        {
          value:
            'I have read the above information, I understand the risks, and I would like to proceed.',
          class: 'option-consent',
          key: 'consent'
        }
      ]
    }
  }
] as const;

const _type = mensexhealthQuestions;
export type MenSexHealthAnswerField = Partial<QuestionAnswerMap<typeof _type>>;

export default mensexhealthQuestions;
